import './infoContainer.css';
import RegularProgressBar from './ProgressBars/RegularProgressBar';
import CircleProgressBar from './ProgressBars/CircleProgressBar';
import KnowledgeContainer from './KnowledgeContainer';

const InfoContainer = (props) => {
    return (
        <div className="info-container info-container-disappear">
            <button onClick={props.toggleNavbar} className="info-container-navbar-button">
                <i className="fas fa-ellipsis-v navbar-button"></i>
            </button>
            <div className="personal-info-container">
                <img src="https://avatars.githubusercontent.com/u/70949854?v=4" alt="profile" />
                <span className="hightlighted-text">Dovydas Tutinas</span>
                <span className="regular-text">Full Stack Junior Developer</span>
            </div>
            <div className="scrolling-container">
                <div className="location-info-container">
                    <div>
                        <span className="regular-white-text">Residence:</span>
                        <span className="regular-text">Lithuania</span>
                    </div>
                    <div>
                        <span className="regular-white-text">City:</span>
                        <span className="regular-text">Vilnius</span>
                    </div>
                    <div>
                        <span className="regular-white-text">Age:</span>
                        <span className="regular-text">29</span>
                    </div>
                    <span className="border-line" />
                </div>
                <div className="languages-container">
                    <span className="hightlighted-text">Languages</span>
                    <div className="language-progress-bars-container">
                        <CircleProgressBar
                            name="Lithuanian"
                            precentage={100}
                            class="progress-bar-lithuanian"
                        />
                        <CircleProgressBar
                            name="English"
                            precentage={80}
                            class="progress-bar-english"
                        />
                        <CircleProgressBar
                            name="Russian"
                            precentage={60}
                            class="progress-bar-russian"
                        />
                    </div>
                    <span className="border-line" />
                </div>
                <div className="general-info-container">
                    <span className="hightlighted-text m-bottom10">Coding</span>
                    <div className="coding-skill-container">
                        <RegularProgressBar
                            name={"HTML"}
                            class={"html"}
                            precentage={"90%"}
                        />
                        <RegularProgressBar
                            name={"JS"}
                            class={"js"}
                            precentage={"80%"}
                        />
                        <RegularProgressBar
                            name={"CSS"}
                            class={"css"}
                            precentage={"70%"}
                        />
                        <RegularProgressBar
                            name={"REACT"}
                            class={"react"}
                            precentage={"70%"}
                        />
                        <RegularProgressBar
                            name={"PHP"}
                            class={"php"}
                            precentage={"50%"}
                        />
                        <RegularProgressBar
                            name={"GATSBY"}
                            class={"gatsby"}
                            precentage={"30%"}
                        />
                        <RegularProgressBar
                            name={"REACT NATIVE (expo)"}
                            class={"reactNative"}
                            precentage={"30%"}
                        />
                    </div>
                    <span className="border-line" />
                </div>
                <div className="general-info-container">
                    <span className="hightlighted-text m-bottom10">Knowledge</span>
                    <KnowledgeContainer text={'Next.js, Gatsby'} />
                    <KnowledgeContainer text={'Redux, Redux Toolkit'} />
                    <KnowledgeContainer text={'Bootstrap, SCSS'} />
                    <KnowledgeContainer text={'Styled Components'} />
                    <KnowledgeContainer text={'MySQL, GraphQL, Firebase'} />
                    <KnowledgeContainer text={'MongoDB, Rest API\'s'} />
                    <KnowledgeContainer text={'CMS\'s - Contentful, Airtable'} />
                    <KnowledgeContainer text={'GIT, Unit Tests, TypeScript'} />
                    <span className="border-line" />
                </div>
                <div className="download-info-container">
                    <div>
                        <a href="https://www.linkedin.com/in/dovydas-tutinas-61b32820/" target="_blank" rel="noreferrer noopener" className="info-anchor">My CV <i class="far fa-file-alt icon"></i></a>
                    </div>
                </div>
                <div className="social-info-container">
                    <a href="https://www.linkedin.com/in/dovydas-tutinas-61b32820/" rel="noreferrer noopener" target="_blank" className="info-anchor"><i className="fab fa-linkedin"></i></a>
                    <a href="https://github.com/Dovtutis" rel="noreferrer noopener" target="_blank" className="info-anchor"><i className="fab fa-github-square"></i></a>
                    <a href="https://twitter.com/Dovtutis" rel="noreferrer noopener" target="_blank" className="info-anchor"><i className="fab fa-twitter-square"></i></a>
                    <a href="https://www.instagram.com/dovtutis/" rel="noreferrer noopener" target="_blank" className="info-anchor"><i className="fab fa-instagram-square"></i></a>
                    <a href="https://www.facebook.com/dovydas.tutinas/" rel="noreferrer noopener" target="_blank" className="info-anchor"><i className="fab fa-facebook-square"></i></a>
                </div>
            </div>
        </div>
    )
}

export default InfoContainer;